<script setup lang="ts">
import { applyOIDCTokens } from '@proj-airi/stage-ui/libs/auth'
import { useAuthStore } from '@proj-airi/stage-ui/stores/auth'
import {
  consumeFlowState,
  exchangeCodeForTokens,
} from '@proj-airi/stage-ui/libs/auth-oidc'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const authStore = useAuthStore()
const error = ref<string | null>(null)

onMounted(async () => {
  const url = new URL(window.location.href)
  const code = url.searchParams.get('code')
  const state = url.searchParams.get('state')
  const providerError = url.searchParams.get('error')

  if (providerError) {
    error.value = url.searchParams.get('error_description') ?? providerError
    return
  }

  if (!code || !state) {
    error.value = 'The authentication callback is missing its code or state.'
    return
  }

  const persisted = consumeFlowState()
  if (!persisted) {
    error.value = 'The authentication flow has expired. Please sign in again.'
    return
  }

  try {
    const tokens = await exchangeCodeForTokens(
      code,
      persisted.flowState,
      persisted.params,
      state,
    )
    await applyOIDCTokens(tokens, persisted.params.clientId)
    await router.replace('/')
  }
  catch (reason) {
    error.value = reason instanceof Error ? reason.message : String(reason)
  }
})

async function tryAgain() {
  await authStore.requestLogin()
}
</script>

<template>
  <main class="center-card">
    <template v-if="error">
      <h1>Sign-in could not be completed</h1>
      <p class="error-text">
        {{ error }}
      </p>
      <button type="button" @click="tryAgain">
        Sign in again
      </button>
    </template>
    <template v-else>
      <h1>Signing you in…</h1>
      <p>Finalizing your AIRI session.</p>
    </template>
  </main>
</template>
